"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const query_string_1 = require("query-string");
const useQueryParam_1 = require("./useQueryParam");
const updateUrlQuery_1 = require("./updateUrlQuery");
const QueryParamProvider_1 = require("./QueryParamProvider");
/**
 * Convert the values in query to strings via the encode functions configured
 * in paramConfigMap
 *
 * @param paramConfigMap Map from query name to { encode, decode } config
 * @param query Query updates mapping param name to decoded value
 */
function encodeQueryParams(paramConfigMap, query) {
    const encodedChanges = {};
    const changingParamNames = Object.keys(query);
    for (const paramName of changingParamNames) {
        if (!paramConfigMap[paramName]) {
            if (process.env.NODE_ENV === 'development') {
                console.warn(`Skipping encoding parameter ${paramName} since it was not configured.`);
            }
            continue;
        }
        encodedChanges[paramName] = paramConfigMap[paramName].encode(query[paramName]);
    }
    return encodedChanges;
}
exports.encodeQueryParams = encodeQueryParams;
/**
 * Given a query parameter configuration (mapping query param name to { encode, decode }),
 * return an object with the decoded values and a setter for updating them.
 */
exports.useQueryParams = (paramConfigMap) => {
    const { history, location } = React.useContext(QueryParamProvider_1.QueryParamContext);
    // read in the raw query
    const rawQuery = React.useMemo(() => location.query ||
        query_string_1.parse(location.search) ||
        {}, [location.query, location.search]);
    // parse each parameter via usQueryParam
    const paramNames = Object.keys(paramConfigMap);
    const decodedValues = {};
    for (const paramName of paramNames) {
        decodedValues[paramName] = useQueryParam_1.useQueryParam(paramName, paramConfigMap[paramName], rawQuery)[0];
    }
    // create a setter for updating multiple query params at once
    const setQuery = React.useCallback((changes, updateType) => {
        // encode as strings for the URL
        const encodedChanges = encodeQueryParams(paramConfigMap, changes);
        // update the URL
        updateUrlQuery_1.default(encodedChanges, location, history, updateType);
    }, [location]);
    // no longer Partial
    return [decodedValues, setQuery];
};
exports.default = exports.useQueryParams;
